export default {
  addAccount: 'Add Account',
  name: 'Name',
  namePlaceholder: 'Please enter name',
  email: 'Email',
  emailPlaceholder: 'Please enter email',
  search: 'Search',
  phone: 'Phone',
  phonePlaceholder: 'Please enter phone',
  role: 'Role',
  rolePlaceholder: 'Please select role',
  status: 'Status',
  createTime: 'Create Time',
  actions: 'Actions',
  edit: 'Edit',
  disable: 'Disable',
  enable: 'Enable',
  delete: 'Delete',
  active: 'Active',
  disabled: 'Disabled',
  operation: 'Operation',
  addAccountTitle: 'Add Account',
  editAccountTitle: 'Edit Account',
  loginEmail: 'Please enter login email',
  selectCountry: 'Please select country',
  password: 'Password',
  passwordPlaceholder: 'Please enter password',
  selectRole: 'Please select role',
  cancel: 'Cancel',
  confirm: 'Confirm',
  resetPassword: 'Reset Password',
  newPassword: 'New Password',
  newPasswordPlaceholder: 'Please enter new password',
  yes: 'Yes',
  no: 'No',
  confirmDelete: 'Are you sure you want to delete this account?',
};
